import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './routes/ProtectedRoute';
import SuperAdminRoutes from './routes/SuperAdminRoutes';
import ManagerRoutes from './routes/ManagerRoutes';
import MentorRoutes from './routes/MentorRoutes';
import StudentRoutes from './routes/StudentRoutes';
import CounsellorRoutes from './routes/CounsellorRoutes';
import PocOwnerRoutes from './routes/PocOwnerRoutes';
import DeepLinkResolver from './routes/DeepLinkResolver';
import ErrorBoundary from './components/common/ErrorBoundary/ErrorBoundary';
import Login from './pages/auth/Login';
import Register from './pages/auth/Register';
import ForgotPassword from './pages/auth/ForgotPassword';
import ResetPassword from './pages/auth/ResetPassword';
import { ToastProvider } from './context/ToastContext';
import './App.css';
//commit message
function App() {
  return (
    <ToastProvider>
    <Router>
      <AuthProvider>
        <div className="app">
          <ErrorBoundary>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/super-admin/*" element={
              <ProtectedRoute allowedRoles={['super_admin']}>
                <SuperAdminRoutes />
              </ProtectedRoute>
            } />
            <Route path="/manager/*" element={
              <ProtectedRoute allowedRoles={['manager']}>
                <ManagerRoutes />
              </ProtectedRoute>
            } />
            <Route path="/mentor/*" element={
              <ProtectedRoute allowedRoles={['mentor']}>
                <MentorRoutes />
              </ProtectedRoute>
            } />
            <Route path="/student/*" element={
              <ProtectedRoute allowedRoles={['student']}>
                <StudentRoutes />
              </ProtectedRoute>
            } />
            <Route path="/counsellor/*" element={
              <ProtectedRoute allowedRoles={['counsellor']}>
                <CounsellorRoutes />
              </ProtectedRoute>
            } />
            <Route path="/poc-owner/*" element={
              <ProtectedRoute allowedRoles={['poc_owner']}>
                <PocOwnerRoutes />
              </ProtectedRoute>
            } />
            {/* Legacy admin route redirect */}
            <Route path="/admin/*" element={<Navigate to="/super-admin" replace />} />

            {/* Role-agnostic deep links generated by the backend
                (reminder_service._deep_link → WhatsApp / email). */}
            <Route path="/assignments/:id" element={<DeepLinkResolver kind="assignments" />} />
            <Route path="/classes/:id" element={<DeepLinkResolver kind="classes" />} />
            <Route path="/projects/:id" element={<DeepLinkResolver kind="projects" />} />
            <Route path="/disputes/:id" element={<DeepLinkResolver kind="disputes" />} />
            <Route path="/competitions" element={<DeepLinkResolver kind="competitions" />} />
            <Route path="/competitions/:id" element={<DeepLinkResolver kind="competitions" />} />

            <Route path="/" element={<Navigate to="/login" replace />} />
            {/* Anything unmatched: never leave a blank screen. */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          </ErrorBoundary>
        </div>
      </AuthProvider>
    </Router>
    </ToastProvider>
  );
}

export default App;